import {
  CompanyInvoiceSettingsForm,
  InvoiceSettingsData,
} from '@/core/domain/invoice/settings/Settings.types';

type HandleReturn = Omit<
  InvoiceSettingsData,
  'companyId' | 'corporateName' | 'fantasyName' | 'cpfCnpj'
>;

export function handlerInvoiceSettings(
  formValues: CompanyInvoiceSettingsForm,
): HandleReturn {
  const {
    nfc,
    nfe,
    nfs,
    culturalIncentive,
    specialTaxRegime,
    nfsLogin,
    nfsPassword,
    ...data
  } = formValues;

  delete data.certificateFile;
  delete data.certificatePassword;
  delete data.certificateEmail;

  return {
    ...data,
    configNfc: data.issueNfc ? nfc : undefined,
    configNfe: data.issueNfe ? nfe : undefined,
    configNfs: data.issueNfs
      ? {
          ...nfs,
          login: nfsLogin,
          password: nfsPassword,
          startDate: nfs.startDate
            ? nfs.startDate.format('YYYY-MM-DD')
            : undefined,
          withheldDefault: nfs.withheldDefault
            ? Boolean(JSON.parse(nfs.withheldDefault))
            : undefined,
        }
      : undefined,
    culturalIncentivator: culturalIncentive,
    specialTaxRegime: specialTaxRegime,
  };
}
